import type { Requisition } from '@/types/requisitions';

// Relocated to the shared constants layer; re-exported for within-feature callers.
export { requisitionStatusConfig } from '@/constants/requisition-constants';

// User-facing copy for the requisition detail drawer.
export const REQUISITION_NO_ACCESS_MESSAGE =
  "You don't have access to this requisition";

export interface TypeConfig {
  label: string;
}

export const requisitionTypeConfig: Record<
  Requisition['requisition_type'],
  TypeConfig
> = {
  new_hire: {
    label: 'New hire',
  },
  backfill: {
    label: 'Backfill',
  },
  internal: {
    label: 'Internal',
  },
};
